/***
 * App theme settings

  app typography theme
  mui default theme
  button theme
*/
import palette from './palette';
import typography from './typography';
import overrides from './overrides';
import { withStyles } from '@material-ui/core/styles';
import { 
  createMuiTheme,
  Button,
} from '@material-ui/core';

const theme = createMuiTheme({
  palette,
  typography,
  overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100
  }
});

export const ButtonAddLogin = withStyles(theme => ({
  root: {
    color: '#8bc34a',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#7684ff',
      backgroundColor: '#fffad5',
    },
  },
}))(Button);

export const ButtonAddReferral = withStyles(theme => ({
  root: {
    color: '#8bc34a',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#c5e1a5',
    },
  },
}))(Button);

export const ButtonSave = withStyles(theme => ({
  root: {
    color: '#2196f3',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#90caf9',
    },
  },
}))(Button);

export const ButtonSignIn = withStyles(theme => ({
  root: {
    color: '#fff',
    backgroundColor: '#8bc34a',
    '&:hover': {
      color: '#c5e1a5',
      backgroundColor: '#fff',
    },
  },
}))(Button);

export const ButtonSaveAndClose = withStyles(theme => ({
  root: {
    color: '#8bc34a',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#c5e1a5',
    },
  },
}))(Button);

export const ButtonRegister = withStyles(theme => ({
  root: {
    color: '#8bc34a',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#c5e1a5',
    },
  },
}))(Button);

export const ButtonListEdit = withStyles(theme => ({
  root: {
    color: '#8bc34a',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#c5e1a5',
    },
  },
}))(Button);

export const ButtonClearForm = withStyles(theme => ({
  root: {
    color: '#ff5722',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#ff5722',
    },
  },
}))(Button);

export const ButtonChangeProgram = withStyles(theme => ({
  root: {
    color: '#ff5722',
    backgroundColor: '#fff',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#ff5722',
    },
  },
}))(Button);

export const ButtonDeactivate = withStyles(theme => ({
  root: {
    color: '#fff',
    backgroundColor: '#b71c1c',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#ef9a9a',
    },
  },
}))(Button);

export default theme;